module.exports = __webpack_public_path__ + "static/media/side_menu_logo.5ea56506.svg";